import { render, staticRenderFns } from "./DicomView_copy.vue?vue&type=template&id=57f440e2&scoped=true&"
import script from "./DicomView_copy.vue?vue&type=script&lang=js&"
export * from "./DicomView_copy.vue?vue&type=script&lang=js&"
import style0 from "./DicomView_copy.vue?vue&type=style&index=0&id=57f440e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f440e2",
  null
  
)

export default component.exports